<template>
    <div>
        <!-- <div style="margin-top: 25px;">
            <el-row :gutter="12">
                <el-col :span="24">
                    <div style="width: 100%;text-align: right;">
                        <el-date-picker
                            style="width: 255px;margin-left: 3px;"
                            v-model="time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="充值开始日期"
                            end-placeholder="充值结束日期"
                            format="yyyy-MM-dd"
                        ></el-date-picker>
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>-->
        <div style="margin-top: 25px;">
            <el-select v-model="selectedStatus" style="width: 130px;margin-left: 5px;" @change="updateTable">
                <el-option :value="-1" label="全部状态"></el-option>
                <el-option :value="0" label="进行中"></el-option>
                <el-option :value="1" label="已取消"></el-option>
                <el-option :value="2" label="已拒绝"></el-option>
                <el-option :value="3" label="已通过"></el-option>
            </el-select>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable" :data="tableData" style="width: 100%" element-loading-text="数据正在加载中">
                <el-table-column prop="aid" label="审批号"></el-table-column>
                <el-table-column prop="nickname" label="申请人"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <div>
                            <span v-if="scope.row.status == 0">审批中</span>
                            <span v-if="scope.row.status == 1">已取消</span>
                            <span v-if="scope.row.status == 2">已拒绝</span>
                            <span v-if="scope.row.status == 3">已通过</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="posttime" label="申请日期" :formatter="dateFormat"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="showDetails(scope.row.aid)">详情</button>
                        <button @click="handle(scope.row,'Y')" v-if="scope.row.status === 0">通过</button>
                        <button @click="handle(scope.row,'N')" v-if="scope.row.status === 0">拒绝</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <el-dialog :visible.sync="detailsDialogVisible" width="50%" :close-on-click-modal="false">
            <h3>{{title}}</h3>
            <div v-for="(item,key) in items" style="width: 50%;display: inline-block;">
                <span style="width:80px;display:inline-block">{{ key }}：</span>
                <span>{{ item }}</span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 10,
            tableData: [],
            time: [],
            detailsDialogVisible: false,
            items: {},
            title: '',
            selectedStatus:-1
        };
    },
    computed: {},
    watch: {},
    methods: {
        handle(approval, opinion) {
            var thiz = this;
            this.$confirm((opinion == 'Y' ? '同意' : '拒绝') + '审批：' + approval.title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios.get(this.$store.getters.getApiValue + '/approval/handle.do', {
                    params: {
                        aid: approval.aid,
                        opinion: opinion
                    }
                }).then(function (response) {
                    var data = response.data;
                    if (data.status == "200") {
                        if (data.data) {
                            thiz.$message.success("操作成功");
                            thiz.updateTable();
                        } else {
                            thiz.$message.error("操作失败");
                        }
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            })
        },
        updateTable() {
            var thiz = this;
            var params = {
                pageId: this.currentPage,
                size: this.pageSize,
                status: this.selectedStatus
            };
            if (this.time != null && this.time.length > 0) {
                params.startDate = this.getStandardDate(this.time[0]);
                params.endDate = this.getStandardDate(this.time[1]);
            }
            axios.get(this.$store.getters.getApiValue + '/approval/forMe.do', {
                params: params
            }).then(function (response) {
                var data = response.data;
                if (data.status == "200") {
                    thiz.tableData = data.data;
                    thiz.total = data.totalCount;
                } else {
                    thiz.$message.error(data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        showDetails(aid) {
            var thiz = this;
            axios
                .get(this.$store.getters.getApiValue + '/approval/getDeposit.do', {
                    params: {
                        aid: aid
                    }
                })
                .then(function (response) {
                    var data = response.data
                    if (data.status == '200') {
                        thiz.items = data.data.items;
                        thiz.title = data.data.parent.title;
                        thiz.detailsDialogVisible = true;
                    } else {
                        thiz.$message.error(data.message)
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    thiz.$message.error('系统异常!请与管理员联系!')
                })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.updateTable();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.updateTable();
        },
        getStandardDate(val) {
            var year = val.getFullYear();
            var month = val.getMonth() + 1;
            var day = val.getDate();
            var hour = val.getHours();
            var minute = val.getMinutes();
            var second = val.getSeconds();
            month = month < 10 ? "0" + month : month;
            day = day < 10 ? "0" + day : day;
            hour = hour < 10 ? "0" + hour : hour;
            minute = minute < 10 ? "0" + minute : minute;
            second = second < 10 ? "0" + second : second;
            return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        },
        dateFormat(row, column) {
            var str = row[column.property];
            if (str == null || str == "") {
                return "";
            } else {
                return this.getStandardDate(new Date(str));
            }
        }
    },
    created() {
    },
    mounted() {
        this.updateTable();
    }
}
</script>
<style scoped>
</style>